// extracted by mini-css-extract-plugin
module.exports = {"activityFlex":"Activity_activityFlex__33FN7","activitiesIcons":"Activity_activitiesIcons__2AK4E","textContainer":"Activity_textContainer__3H5Be"};